import * as yup from "yup";

export const schema = yup
    .object({
        serviceTitle: yup
            .string()
            .required("Please enter a title for the service"),
        serviceTypes: yup
            .array()
            .min(1, "Please select at least one type of service")
            .required("Please select the type of service"),
        appointmentPrice: yup
            .number()
            .typeError("Please enter a valid number")
            .required("Please enter the price of appointment")
            .min(0.01, "Price should be greater"),
        appointmentLength: yup
            .string()
            .required("Please enter the length of the appointment")
            .test("is-greater", "Time should be greater", function (value) {
                if (!value) return false;

                const [h, m] = value.split(":").map(Number);
                return h * 60 + m > 0;
            }),
        turnaroundLength: yup
            .string()
            .required("Please enter the length of turnaround")
            .test("is-greater", "Time should be greater", function (value) {
                if (!value) return false;

                const [h, m] = value.split(":").map(Number);
                return h * 60 + m > 0;
            }),
    })
    .required();
